/* cf-calc-mobile-cta.js - Click Fencing, 2026-09-09
 *
 * WHY. Measured in GA4 over the 30 days to 2026-09-09, by USERS not events:
 *
 *            calculator  started  price shown  gate added  quote saved  ENQUIRY
 *   mobile       127        79         60          44           1          0
 *   desktop       25        20         18          16          11          6
 *
 * Mobile is 82% of calculator traffic and produced ZERO enquiries. Desktop
 * converts view->enquiry at 24%.
 *
 * Rendered on a real iPhone 14 Pro (393x660) the cause is structural, not broken
 * CSS - horizontal overflow is 0 and no input is under 16px, so the Aug 2026
 * mobile work is holding. What is wrong is LENGTH and ORDER:
 *
 *   - .calculator-header is 268px, so screen one is all title and blurb and the
 *     first control sits at ~700px, below the fold on arrival.
 *   - the desktop side column stacks on mobile, putting Configuration Summary
 *     (350px) + Selected Components (371px) + Optional Add-ons (417px) BETWEEN
 *     the price and the button.
 *   - the "How to Measure" block adds ~1,000px more.
 *   - net: the page runs 6.7 screens and Add to Cart lands 4.6 screens down.
 *
 * WHAT THIS DOES (mobile <=749px, calculator pages only)
 *   1. A sticky bar carrying the running total and the step's primary action.
 *      It CLICKS THE SITE'S OWN BUTTON - it does not reimplement any of them -
 *      the same rule cf-checkout-smooth.js follows on /pages/quote-review.
 *      It hides itself while the real button is already on screen, so there are
 *      never two live buttons competing.
 *   2. Collapses the Instructions block behind a toggle, shut by default.
 *   3. Trims the hero on mobile so the first control is above the fold.
 *   4. Floors calculator labels at 14px - six were measured at 13.5px, under the
 *      site's own typography floor.
 *
 * WHAT IT DOES NOT TOUCH: no price, no variant, no quantity, no cart line, no
 * solver. Display and navigation only. It also leaves #section-preview and
 * #quote-breakdown alone - those are wide BY NATURE and must keep overflow-x:auto
 * (see cf-mobile.liquid trap 1; capping them squashes a scale drawing).
 *
 * SAFETY: every entry point is try/caught. If anything throws, the page is left
 * exactly as the theme rendered it.
 */
(function () {
  'use strict';
  if (window.__cfCalcMobileCta) return;
  window.__cfCalcMobileCta = true;

  var TAG = '[cf-calc-mobile-cta]';
  var PAGES = /\/pages\/(glass-fencing|fence-calculator|blade-fence-calculator|flat-top-fence-calculator|perfmesh-fence|base-mount-batten-calculator)/;
  if (!PAGES.test(location.pathname)) return;

  var MQ = window.matchMedia('(max-width: 749px)');

  function injectCss() {
    if (document.getElementById('cf-cmc-css')) return;
    var s = document.createElement('style');
    s.id = 'cf-cmc-css';
    s.textContent = [
      '@media (max-width: 749px){',
      '  body .calculator-page .calculator-header{padding-top:10px!important;padding-bottom:8px!important}',
      '  body .calculator-page .calculator-header h1{font-size:26px!important;line-height:1.15!important;margin:0 0 6px!important}',
      '  body .calculator-page .calculator-header p{display:none!important}',
      '  body .calculator-page label,body .calculator-page .form-label,',
      '  body .calculator-page .component-label{font-size:14px!important}',
      '  body .calculator-page .cf-cmc-instr-hidden{display:none!important}',
      '  body .calculator-page .cf-cmc-instr-toggle{display:block;width:100%;margin:6px 0 2px;padding:11px 14px;',
      '    font-size:15px;font-weight:600;text-align:left;background:#eef4fb;color:#0b4f8a;',
      '    border:1px solid #cfe0f0;border-radius:8px;min-height:44px}',
      '  #cf-cmc-bar{position:fixed;left:0;right:0;bottom:0;z-index:2147482000;',
      '    display:flex;align-items:center;gap:12px;padding:10px 12px;',
      '    background:#fff;border-top:1px solid #d9e2ea;box-shadow:0 -3px 14px rgba(12,43,66,.13);',
      '    font-family:inherit;transform:translateY(110%);transition:transform .18s ease}',
      '  #cf-cmc-bar.cf-cmc-in{transform:translateY(0)}',
      '  #cf-cmc-bar .cf-cmc-total{flex:1;min-width:0;line-height:1.2}',
      '  #cf-cmc-bar .cf-cmc-lbl{display:block;font-size:11px;letter-spacing:.06em;text-transform:uppercase;color:#5b7285}',
      '  #cf-cmc-bar .cf-cmc-amt{display:block;font-size:19px;font-weight:700;color:#0c2b42;',
      '    font-variant-numeric:tabular-nums;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
      '  #cf-cmc-bar button{flex:0 0 auto;min-height:48px;padding:0 20px;border:0;border-radius:8px;',
      '    background:#1e80c8;color:#fff;font-size:16px;font-weight:700;cursor:pointer}',
      '  #cf-cmc-bar button[disabled]{background:#a9c2d2;cursor:default}',
      '  body.cf-cmc-on .cf-plans{bottom:78px!important}',
      '}'
    ].join('');
    document.head.appendChild(s);
  }

  function visible(el) {
    if (!el || el.offsetParent === null) return false;
    var r = el.getBoundingClientRect();
    return r.width > 1 && r.height > 1;
  }

  function currentAction() {
    /* 2026-10-08: Blade's Review button is #btn-diy-checkout - without it Blade's Review had no bar and
       Add to Cart sat 8 screens down (phone deep dive). */
    var ids = ['add-to-cart', 'btn-diy-checkout', 'nav-next', 'sections-next-btn'];
    for (var i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (visible(el)) return el;
    }
    return null;
  }

  function inViewport(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight - 60 && r.bottom > 0;
  }

  function runningTotal() {
    var el = document.querySelector('.breakdown-total');
    if (!el) return null;
    var m = (el.innerText || '').match(/\$\s?[\d,]+\.\d{2}/);
    if (!m) return null;
    var v = m[0].replace(/\s/g, '');
    /* A zero total means nothing is configured yet - "YOUR FENCE $0.00" reads as
       broken. Show the encouragement copy instead until there is a real price. */
    if (parseFloat(v.replace(/[$,]/g, '')) <= 0) return null;
    return v;
  }

  var bar, amtEl, lblEl, btnEl, target = null;

  function buildBar() {
    if (document.getElementById('cf-cmc-bar')) return;
    bar = document.createElement('div');
    bar.id = 'cf-cmc-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Fence total and next step');
    var t = document.createElement('div');
    t.className = 'cf-cmc-total';
    lblEl = document.createElement('span');
    lblEl.className = 'cf-cmc-lbl';
    lblEl.textContent = 'Your fence';
    amtEl = document.createElement('span');
    amtEl.className = 'cf-cmc-amt';
    amtEl.textContent = 'Building';
    t.appendChild(lblEl);
    t.appendChild(amtEl);
    btnEl = document.createElement('button');
    btnEl.type = 'button';
    btnEl.textContent = 'Next';
    btnEl.addEventListener('click', function () {
      try { if (target && visible(target)) target.click(); }
      catch (e) { console.warn(TAG, e); }
    });
    bar.appendChild(t);
    bar.appendChild(btnEl);
    document.body.appendChild(bar);
  }

  function refresh() {
    try {
      if (!MQ.matches) {
        if (bar) bar.classList.remove('cf-cmc-in');
        document.body.classList.remove('cf-cmc-on');
        return;
      }
      buildBar();
      target = currentAction();

      if (!target || inViewport(target)) {
        bar.classList.remove('cf-cmc-in');
        document.body.classList.remove('cf-cmc-on');
        document.body.style.paddingBottom = '';
        return;
      }

      var total = runningTotal();
      if (total) { lblEl.textContent = 'Your fence'; amtEl.textContent = total; }
      else { lblEl.textContent = 'Step'; amtEl.textContent = 'Keep going'; }

      var label = (target.textContent || '').trim();
      btnEl.textContent = /add to cart/i.test(label) ? 'Add to Cart' : 'Next';
      btnEl.disabled = !!target.disabled;

      bar.classList.add('cf-cmc-in');
      document.body.classList.add('cf-cmc-on');
      document.body.style.paddingBottom = (bar.offsetHeight + 8) + 'px';
    } catch (e) { console.warn(TAG, 'refresh', e); }
  }

  function collapseInstructions() {
    try {
      if (!MQ.matches) return;
      var heads = document.querySelectorAll('.calculator-column h3, .calculator-column h2');
      for (var i = 0; i < heads.length; i++) {
        var h = heads[i];
        if (!/^instructions$/i.test((h.textContent || '').trim())) continue;
        var body = h.parentElement && h.parentElement.querySelector('.info-content');
        if (!body || body.dataset.cfCmc) continue;
        body.dataset.cfCmc = '1';
        body.classList.add('cf-cmc-instr-hidden');
        (function (bodyEl) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'cf-cmc-instr-toggle';
          btn.setAttribute('aria-expanded', 'false');
          btn.textContent = 'How to measure your pool area';
          btn.addEventListener('click', function () {
            var open = bodyEl.classList.toggle('cf-cmc-instr-hidden') === false;
            btn.setAttribute('aria-expanded', String(open));
          });
          bodyEl.parentElement.insertBefore(btn, bodyEl);
        })(body);
      }
    } catch (e) { console.warn(TAG, 'instructions', e); }
  }

  function tick() { refresh(); collapseInstructions(); }

  function start() {
    try {
      injectCss();
      tick();
      var pending = null;
      var obs = new MutationObserver(function () {
        if (pending) return;
        pending = setTimeout(function () { pending = null; tick(); }, 180);
      });
      obs.observe(document.body, { childList: true, subtree: true, characterData: true });
      window.addEventListener('scroll', function () { refresh(); }, { passive: true });
      window.addEventListener('resize', tick, { passive: true });
      if (MQ.addEventListener) MQ.addEventListener('change', tick);
      console.log(TAG, 'installed');
    } catch (e) { console.warn(TAG, 'start', e); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
